import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { useTranslation } from "react-i18next";
import {
  Button,
} from "@mui/material";
import { styles } from "../styles/selectionStyles";
import { logout } from "../slices/authSlice";

const DriverSelectionPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const driverInfo = useAppSelector((state) => state.auth.driverInfo);

  if (!driverInfo) {
    return <Navigate replace to={"/driver-login"} />;
  }

  const handleLogout = () => {
    dispatch(logout());
    navigate("/driver-login");
  };

  return (
    <div style={styles.container}>
      <div style={styles.buttonContainer}>
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={() => navigate("/driver-orders")}
        >
          {t("btnDriverOrder")}
        </Button>

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={() => navigate("/driver-history")}
        >
          {t("btnDriverHistory")}
        </Button>

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={() => navigate("/driver-info")}
        >
          {t("selectMyInfo")}
        </Button>

        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={() => navigate("/driver-password")}
        >
          {t("resetPassword")}
        </Button>
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 0, mb: 0 }}
          onClick={handleLogout}
        >
          {t("btnLogout")}
        </Button>
      </div>
    </div>
  );
};

// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "column" as const,
//     alignItems: "center",
//     justifyContent: "center",
//     height: "50vh",
//   },
//   buttonContainer: {
//     display: "flex",
//     flexDirection: "column" as const,
//     //gap: "15px", // 按钮间距
//     gap: "5px", // 按钮间距
//     width: "200px", // 按钮宽度统一
//     alignItems: "center",
//   },
//   button: {
//     padding: "10px 20px",
//     fontSize: "18px",
//     border: "1px solid #ccc",
//     borderRadius: "5px",
//     backgroundColor: "#6a1b9a",
//     color: "white",
//     cursor: "pointer",
//     width: "200px", // 按钮宽度统一
//     textAlign: "center" as const,
//   },
// };

export default DriverSelectionPage;
